import axios from 'axios'
import {BaseResponse, IDropdown, IDropdownQuery, Pagination, TPermissions} from 'src/app/models'

type IDropdownResponse = BaseResponse<Pagination<IDropdown[]>>

export const DROPDOWN = '/api/v1/admins/dropdown'

export const getDropdownExportType = (params?: IDropdownQuery) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/export/export_type`, {params})
}

export const getDropdownExportModule = (params?: IDropdownQuery) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/export/export_module`, {params})
}

export const getDropdownDivision = (params?: IDropdownQuery & {show_pic?: boolean}) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/division`, {params})
}

export const getDropdownAdmin = (
  params?: IDropdownQuery & {
    department_ids?: string[]
    statuses?: string[]
    level_types?: string[]
    permissions?: TPermissions[]
  }
) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/users/admins`, {params})
}

export const getDropdownAgent = (
  params?: IDropdownQuery & {department_ids?: string[]; statuses?: string[]}
) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/users/agents`, {params})
}

export const getDropdownLocation = (params?: IDropdownQuery) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/locations`, {params})
}

export const getDropdownJob = (params?: IDropdownQuery) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/tasks`, {params})
}

export const getDropdownOrganization = (params?: IDropdownQuery) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/organizations`, {params})
}

export const getDropdownCompany = (params?: IDropdownQuery & {organization_ids?: string[]}) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/companies`, {params})
}

export const getDropdownDepartment = (
  params?: IDropdownQuery & {organization_ids?: string[]; company_ids?: string[]}
) => {
  return axios.get<BaseResponse<Pagination<{label: string; options: IDropdown[]}[]>>>(
    `${DROPDOWN}/departments`,
    {params}
  )
}

export const getDropdownDepartmentWorkOrder = (
  params?: IDropdownQuery & {company_ids?: string}
) => {
  return axios.get<BaseResponse<Pagination<{label: string; options: IDropdown[]}[]>>>(
    `${DROPDOWN}/company/${params?.company_ids}/departments`
  )
}

export const getDropdownDepartmentRequestor = (
  params?: IDropdownQuery & {company_ids?: string[]}
) => {
  return axios.get<BaseResponse<Pagination<{label: string; options: IDropdown[]}[]>>>(
    `${DROPDOWN}/wo/requestor-departments`,
    {params}
  )
}

export const getDropdownDepartmentDestination = (
  params?: IDropdownQuery & {company_ids?: string[]}
) => {
  return axios.get<BaseResponse<Pagination<{label: string; options: IDropdown[]}[]>>>(
    `${DROPDOWN}/wo/destination-departments`,
    {params}
  )
}

export const getDropdownTaskTemplates = (params?: IDropdownQuery) => {
  return axios.get<IDropdownResponse>(`${DROPDOWN}/tasks-templates`, {params})
}
